'use strict';

var ScrollWatch = require('scrollwatch');
var scrollToElement = require('scroll-to-element');
var $ = (typeof window !== "undefined" ? window.jQuery : typeof global !== "undefined" ? global.jQuery : null);
var api = {};
var dom = {};
var menuItems = [];
var options = {

	floatStartY: 248

};


var setupDom = function(){

	dom.window = $(window);
	dom.document = $(document);
	dom.body = $('body');
	dom.controls = $('.floating-menu__nav');
	dom.floatingControls = $('.floating-menu__nav--floating');
	dom.fixedControlItems = $('.floating-menu__nav--fixed .floating-menu__nav-item');
	dom.floatingControlItems = $('.floating-menu__nav--floating .floating-menu__nav-item');

};

var setupMenuArray = function(){

	dom.floatingControlItems.each(function(i, el){

		menuItems[i] = $(el).attr('data-section-id');

	});

};

var addEventHandlers = function(){

	// this hover class is necessary to highlight the
	// nav icons and text together even though they are
	// "split apart" so that the text nav can float
	dom.controls.find('li').hover(function(){

		var sectionId = $(this).attr('data-section-id');

		dom.controls.find('[data-section-id="' + sectionId + '"]').addClass('floating-menu__nav-item--hover');

	}, function(){

		var sectionId = $(this).attr('data-section-id');
		
		dom.controls.find('[data-section-id="' + sectionId + '"]').removeClass('floating-menu__nav-item--hover');

	});


	// clicking on the navigation li should scroll to its
	// associated section
	dom.document.on('click', '.floating-menu__nav-item', function(e){

		var sectionId = $(this).attr('data-section-id');

		e.preventDefault();

		scrollToElement({
			element: '.floating-menu__block[data-section-id="' + sectionId + '"]',
			force: true,
			speed: 700,
			callback: function(){
				window.location.hash = '#' + sectionId
			}
		});

	});

	dom.window.on('load', function(){

		var anchorId = window.location.hash.length ? '.' + window.location.hash.slice(1) : '';

		dom.body.addClass('floating-menu__ready-for-highlights');

		highlightSectionNavItem($('.what-we-do-center-element' + anchorId));

	});

};

var highlightSectionNavItem = function($centerElement){

	var focusedItemId = $centerElement.closest('.floating-menu__block').attr('data-section-id');
	var focusedItemIdx = menuItems.indexOf(focusedItemId);

	dom.floatingControlItems.removeClass('floating-menu__nav-item--selected');
	dom.fixedControlItems.removeClass('floating-menu__nav-item--selected');

	$('[data-section-id="' + menuItems[focusedItemIdx] + '"]').addClass('floating-menu__nav-item--selected');

};

var setupScrollwatch = function(){

	var navWatch;
	var sectionWatch;


	if(window.scrollY >= options.floatStartY) {

		dom.floatingControls.addClass('floating-menu__nav--active');

	}


	// watch the navigation icons, once they leave view, activate the "floating" textual nav
	navWatch = new ScrollWatch({

		onElementInView: function(){

			dom.floatingControls.removeClass('floating-menu__nav--active');

		},

		onElementOutOfView: function(){

			dom.floatingControls.addClass('floating-menu__nav--active');

		},

		// watch: '.floating-menu__nav--fixed',
		watch: 'header',

		watchOnce: false,

		scrollThrottle: 50

	});


	// watch the "center elements" in each section, once they enter into view
	// highlight the correct link in the section navigation
	sectionWatch = new ScrollWatch({

		onElementInView: function(data){

			var $centerElement = $(data.el);
			
			highlightSectionNavItem($centerElement);

		},

		watchOnce: false,

		watch: '.floating-menu__block-center-element',

		scrollThrottle: 50

	});


};


api.init = function(){

	setupDom();

	setupMenuArray();

	addEventHandlers();

	setupScrollwatch();

};


module.exports = api;
